import { isGuid } from "./string";

export const BOARD_TASKS_LABEL = "Board Tasks";

export const BOARD_TASK_MODES = {
  MY: "mine",
  ALL: "all",
  HIDE: "hide",
};

export const BOARD_TASK_MODE_OPTIONS = [
  { key: BOARD_TASK_MODES.MY, label: "My Tasks" },
  { key: BOARD_TASK_MODES.ALL, label: "All Tasks" },
  { key: BOARD_TASK_MODES.HIDE, label: "Hide Tasks" },
];

export const calendarLabel = (calendar) => {
  return calendar?.title ?? calendar?.caption ?? calendar?.name ?? "Calendar";
};

export const isBoardTasksCalendar = (calendar) => {
  return String(calendarLabel(calendar) || "").trim().toLowerCase() === BOARD_TASKS_LABEL.toLowerCase();
};

export const boardTaskCalendarColorKey = (calendar, fallbackUuid = null) => {
  return isBoardTasksCalendar(calendar) ? BOARD_TASKS_LABEL : (calendar?.uuid ?? fallbackUuid);
};

export const currentPersonUuid = (auth) => {
  if (isGuid(auth?.user?.uuid)) return auth.user.uuid;
  if (isGuid(auth?.user?.Person?.uuid)) return auth.user.Person.uuid;
  return null;
};

export const eventBoardTask = (event) => {
  return event?.boardTask ?? event?.db?.boardTask ?? null;
};

export const isBoardTaskEvent = (event) => {
  return Boolean(eventBoardTask(event)) ||
    isBoardTasksCalendar(event?.calendar) ||
    isBoardTasksCalendar(event?.db?.calendar);
};

export const boardTaskAssignedToUuid = (event) => {
  return eventBoardTask(event)?.assignedToUuid ?? null;
};

export const boardTaskEventMatchesMode = (event, mode, personUuid) => {
  if (!isBoardTaskEvent(event)) return true;
  if (mode === BOARD_TASK_MODES.HIDE) return false;
  if (mode === BOARD_TASK_MODES.ALL) return true;

  return isGuid(personUuid) && boardTaskAssignedToUuid(event) === personUuid;
};
